import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTokenValid } from '../api';

export default function PrivateRoute({ children }) {
  const { auth } = useAuth();
  if (!auth || auth.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }
  // A stored-but-expired token would otherwise render the admin shell while
  // every API call fails with 401 — which a page refresh cannot recover from.
  // Send the user to login with a flag so they see why they were signed out.
  if (!isTokenValid(auth.token)) {
    return <Navigate to="/login?expired=1" replace />;
  }
  return children;
}
